export const STATUS_LABELS = {
  RASCUNHO: "Rascunho",
  AGUARDANDO_ESTOQUE: "Aguardando Estoque",
  DEVOLVIDO_ESTOQUE: "Devolvido pelo Estoque",
  AGUARDANDO_MASTER: "Aguardando Master Data",
  EM_CADASTRO: "Em cadastro",
  CADASTRADO: "Cadastrado",
  JA_EXISTENTE: "Já existente",
  CANCELADO: "Cancelado",
};

export const STATUS_COLORS = {
  RASCUNHO: "default",
  AGUARDANDO_ESTOQUE: "warning",
  DEVOLVIDO_ESTOQUE: "error",
  AGUARDANDO_MASTER: "info",
  EM_CADASTRO: "secondary",
  CADASTRADO: "success",
  JA_EXISTENTE: "success",
  CANCELADO: "default",
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(value.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("pt-BR");
};
